import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { PetitionService } from 'src/app/services/petition.service';
import { UploadFileService } from 'src/app/services/upload-file.service';


declare var $: any;
declare var google:any; 

@Component({
  selector: 'app-seguridad-visitas',
  templateUrl: './visitas.component.html'
})
export class SeguridadVisitasComponent implements OnInit {
  Form: FormGroup;
  public user_logged: any;
  public condominios_data: any;
  public api_error: any;
  public membresias_data: any;
  public membresiaID: any;
  FiletoUpload: any;
	file: File;
  strImage: any;
  closeResult: string;
  imgurl: any;
  public idCondo: any;
  constructor(
    private data_service: DataService,
    private petition_service: PetitionService,
    private alert_service: AlertService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private uploadFileService: UploadFileService
    ) {
      this.user_logged = JSON.parse(localStorage.getItem('currentUser'));
      this.data_service.CondominioSeguridad(this.user_logged.id)
    .subscribe((res) => {
      console.log(res)
      localStorage.setItem('Seguridad_data',JSON.stringify(res));
    }, (error) => {
      console.log(error)
    })
      this.idCondo = JSON.parse(localStorage.getItem('Seguridad_data'));
      this.GetVisitas();
   }
   Visitas: any;
   GetVisitas(){
     this.data_service.SeguridadVisitas(this.idCondo.condominio_id)
     .subscribe((res)=>{
      console.log(res)
      this.Visitas = res;
    }, (error) => {
      console.log(error)
    })
   }
   EmergenciasS: any;
   Emergencias(){
    this.data_service.ListadoEmergencias(this.idCondo.condominio_id)
    .subscribe((res)=>{
     console.log(res)
     this.EmergenciasS = res;
   }, (error) => {
     console.log(error)
   })
   }
   update_proyecto(estado: number, id_reserva: number){
    this.petition_service.put('condominio_usuario_visita_control', {"estado": estado}, id_reserva).subscribe(
      (data: any) => {
        this.alert_service.show_swall('Visita actualizada','Se ha cambiado el estado de la visita','success');
        this.GetVisitas();
      },
      (err: any) => {
        this.alert_service.show_error();  
      }
    )
  }
   ngOnInit(){
    this.data_service.CondominioSeguridad(this.user_logged.id)
    .subscribe((res) => {
      console.log(res)
      localStorage.setItem('Seguridad_data',JSON.stringify(res));
    }, (error) => {
      console.log(error)
    })
    }  
}